import { render, staticRenderFns } from "./NpsmEdit.vue?vue&type=template&id=392e9e88&scoped=true&"
import script from "./NpsmEdit.vue?vue&type=script&lang=js&"
export * from "./NpsmEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e9e88",
  null
  
)

export default component.exports